import { createContext, useContext } from 'react'

// Shared read models + action handlers for the task UI. Provided by Taskboard.
export const TaskboardContext = createContext(null)

export function useTaskboard() {
  const ctx = useContext(TaskboardContext)
  if (!ctx) throw new Error('useTaskboard must be used within Taskboard')
  return ctx
}
